module.exports = __webpack_public_path__ + "static/assets/893f3ba3c53bfada87d182c56d693b02.svg";